import React from 'react';
import { Descriptions } from 'antd';
import { formatDateTime } from '../../../utils/dateTimeUtil';
import Vehicle from '../../../core/models/Vehicle';

interface IProps {
  column: number;
  vehicle: Vehicle;
}

const ViewVehicleSummery: React.FC<IProps> = ({ column, vehicle }) => {
  return (
    <Descriptions
      size='small'
      column={column}
      layout='horizontal'
      labelStyle={{ fontWeight: 'bold' }}
    >
      <Descriptions.Item label='Created By'>{vehicle?.createdBy}</Descriptions.Item>
      <Descriptions.Item label='Created On'>
        {formatDateTime(vehicle?.createdDate)}
      </Descriptions.Item>
      <Descriptions.Item label='Updated By'>{vehicle?.updatedBy}</Descriptions.Item>
      <Descriptions.Item label='Updated On'>
        {formatDateTime(vehicle?.updatedDate)}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default ViewVehicleSummery;
